import {
  REQUEST_REPORT_FIELDS,
  RESPONSE_REPORT_FIELDS,
  REQUEST_REPORT_FIELDS_FAILURE,
  RESPONSE_CANCEL_REPORT_FIELDS,
  CLEAR_REPORT_FIELDS
} from '../actions/reportFieldsActions'
import { cancelRequest } from '../shared/services/cancelRequest.service'

import { states } from './queriesStates'

const initialState = {
  dataState: states.NOT_REQUESTED,
  data: [],
  errors: [],
  currentId: '',
  currentType: null,
  isCanceled: false,
  cancel: cancelRequest()
}

const reportFieldsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_REPORT_FIELDS:
      return Object.assign(
        {},
        state,
        {
          isCanceled: false,
          dataState: states.REQUEST
        }
      )
    case RESPONSE_REPORT_FIELDS:
      const { data, id, type } = action.payload

      return Object.assign(
        {},
        state,
        {
          dataState: states.READY,
          data: data,
          currentId: id,
          currentType: type
        }
      )
    case REQUEST_REPORT_FIELDS_FAILURE:
      return Object.assign(
        {},
        state,
        {
          dataState: states.FAILURE,
          errors: action.errors
        }
      )
    case RESPONSE_CANCEL_REPORT_FIELDS:
      return Object.assign(
        {},
        state,
        {
          isCanceled: true,
          cancel: cancelRequest()
        }
      )
    case CLEAR_REPORT_FIELDS:
      return Object.assign(
        {},
        state,
        {
          dataState: states.NOT_REQUESTED,
          data: [],
          errors: [],
          currentId: '',
          currentType: null,
          isCanceled: false
        }
      )
    default:
      return state
  }
}

export default reportFieldsReducer